import { render } from "./VerificationStatus.vue?vue&type=template&id=0bf77754&scoped=true&ts=true"
import script from "./VerificationStatus.vue?vue&type=script&lang=ts"
export * from "./VerificationStatus.vue?vue&type=script&lang=ts"

import "./VerificationStatus.vue?vue&type=style&index=0&id=0bf77754&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf77754"]])

export default __exports__